<template>

    <!-- Modale liste des utilisateurs : gabarit cf-dialog (charte cf-/ds-). -->
    <div v-if="isdisplay" class="open ti-modal" aria-overlay="false" tabindex="-1" style="z-index: 50;">
        <div class="hs-overlay-open:mt-7 ti-modal-box mt-0 ease-out min-h-[calc(100%-3.5rem)] flex items-center cf-w-99">
            <div class="ti-modal-content" style="width: 100%!important;">

                <div class="ti-modal-header cf-modal-head">
                    <div class="cf-modal-head__main">
                        <span class="cf-modal-head__icon"><i class="ri-team-line"></i></span>
                        <div>
                            <h6 class="modal-title">{{ titlemodal }}</h6>
                            <p class="cf-modal-head__sub">Gestion des utilisateurs de l'application</p>
                        </div>
                    </div>
                    <button @click="close" type="button" class="hs-dropdown-toggle ti-modal-close-btn">
                        <span class="sr-only">Fermer</span>
                        <i class="ri-close-line text-lg"></i>
                    </button>
                </div>

                <div class="ti-modal-body">

                    <div class="box overflow-hidden">

                        <div class="box-header justify-between" style="display: block">
                            <div class="grid grid-cols-12 gap-x-6">

                                <div class="xl:col-span-3 col-span-12 mt-4 mb-4">
                                    <input v-model="searchword" @input="debouncedSearch"
                                           class="form-control form-control-lg w-full" type="text"
                                           placeholder="Rechercher par nom, login, groupe ou rôle"
                                           aria-label="recherche">
                                </div>

                                <div class="xl:col-span-2 col-span-12 mt-4 mb-4">
                                    <select v-model="statusFilter" class="form-control form-control-lg w-full" aria-label="Statut">
                                        <option value="">Tous les statuts</option>
                                        <option value="active">Actifs</option>
                                        <option value="inactive">Inactifs</option>
                                    </select>
                                </div>

                                <div class="xl:col-span-2 col-span-12 mt-4 mb-4">
                                    <select v-model="roleFilter" class="form-control form-control-lg w-full" aria-label="Rôle">
                                        <option value="">Tous les rôles</option>
                                        <option v-for="role in rolesList" :key="role.value" :value="role.value">
                                            {{ role.label }}
                                        </option>
                                    </select>
                                </div>

                                <div class="xl:col-span-2 col-span-12 mt-4 mb-4 flex items-center justify-center">
                                    <span class="cf-st"
                                          :class="quota.used >= quota.max ? 'cf-st--ko' : 'cf-st--info'"
                                          :title="quota.used >= quota.max ? 'Limite de licence atteinte' : 'Licences utilisées'">
                                        {{ quota.used }} / {{ quota.max }} licence(s)
                                    </span>
                                </div>

                                <div class="xl:col-span-2 col-span-12 mt-4 mb-4">
                                    <button @click="btnajouter"
                                            :disabled="quota.used >= quota.max"
                                            :title="quota.used >= quota.max ? 'Limite de licence atteinte' : ''"
                                            class="ti-btn ti-btn-primary-full !py-1 !px-2 !text-[0.75rem] w-full disabled:opacity-50 disabled:cursor-not-allowed">
                                        <i class="ri-add-line align-middle"></i> Ajouter
                                    </button>
                                </div>

                                <div class="xl:col-span-1 col-span-12 mt-4 mb-4">
                                    <select v-model="DefaultperPage" class="cf-select-pagesize w-full"
                                            aria-label="Taille de page" title="Affichage">
                                        <option value="10">10</option>
                                        <option value="25">25</option>
                                        <option value="50">50</option>
                                        <option value="100">100</option>
                                    </select>
                                </div>

                            </div>
                        </div>

                        <div class="box-body !p-0">
                            <div class="table-responsive">
                                <div class="flex flex-col cf-h-500">
                                    <div class="flex-grow overflow-auto">

                                        <table class="w-full border table mytable table-hover whitespace-nowrap min-w-full">
                                            <thead>
                                            <tr>
                                                <th scope="col" class="cf-th">N°</th>
                                                <th scope="col" class="cf-th cf-th--triable" @click="sortBy('name')">
                                                    Utilisateur
                                                    <i class="cf-tri cf-tri--on"
                                                       :class="sortDirection === 'asc' ? 'ri-arrow-up-line' : 'ri-arrow-down-line'"></i>
                                                </th>
                                                <th scope="col" class="cf-th">Login</th>
                                                <th scope="col" class="cf-th">Groupe</th>
                                                <th scope="col" class="cf-th">Rôle</th>
                                                <th scope="col" class="cf-th">Statut</th>
                                                <th scope="col" class="cf-th">Annexes</th>
                                                <th scope="col" class="cf-th">Créé le</th>
                                                <th scope="col" class="cf-th">Action</th>
                                            </tr>
                                            </thead>
                                            <tbody>

                                            <template v-if="filteredData.length">
                                                <tr class="border-t hover:bg-gray-200"
                                                    v-for="(user, index) in paginatedData" :key="index">

                                                    <td data-label="N° : " class="cf-num">{{ (page - 1) * perPage + index + 1 }}</td>

                                                    <td data-label="Utilisateur : ">
                                                        <div class="flex items-center gap-3">
                                                            <span class="cf-avatar">{{ getUserInitials(user.name) }}</span>
                                                            <div>
                                                                <span class="font-semibold">{{ user.name }}</span>
                                                                <span v-if="user.useline === 1" class="cf-pill">Admin</span>
                                                                <span class="block cf-faint text-xs">{{ user.creerpar || 'Système' }}</span>
                                                            </div>
                                                        </div>
                                                    </td>

                                                    <td data-label="Login : ">
                                                        <span class="cf-num text-xs">{{ user.login }}</span>
                                                    </td>

                                                    <td data-label="Groupe : ">
                                                        <span class="cf-st" :class="getGroupBadgeClass(user.groupeusers)">
                                                            {{ user.groupeusers || 'Non défini' }}
                                                        </span>
                                                    </td>

                                                    <td data-label="Rôle : ">{{ user.nameprofil || 'Non renseigné' }}</td>

                                                    <td data-label="Statut : ">
                                                        <span class="cf-st" :class="user.useline === 1 ? 'cf-st--ok' : 'cf-st--neutre'">
                                                            {{ user.useline === 1 ? 'Actif' : 'Inactif' }}
                                                        </span>
                                                    </td>

                                                    <td data-label="Annexes : ">
                                                        <div class="flex flex-wrap gap-1">
                                                            <span v-for="(ag, i) in (user.agence || [])" :key="i"
                                                                  class="cf-st cf-st--info">
                                                                {{ ag.name || ag }}
                                                            </span>
                                                            <span v-if="!user.agence || user.agence.length === 0"
                                                                  class="cf-faint">-</span>
                                                        </div>
                                                    </td>

                                                    <td data-label="Créé le : ">
                                                        <span class="cf-num">{{ formatDate(user.creerle) }}</span>
                                                        <span class="block cf-faint text-xs cf-num">{{ formatTime(user.creerle) }}</span>
                                                    </td>

                                                    <td data-label="Action : ">
                                                        <div class="us-actions relative">
                                                            <button @click="toggleActionsDropdown(index)"
                                                                    class="ds-btn-ghost !py-1 !px-2 !text-[0.75rem]"
                                                                    :aria-expanded="activeDropdown === index" aria-label="Actions">
                                                                <i class="ri-more-2-fill"></i>
                                                            </button>
                                                            <ul v-if="activeDropdown === index" class="ti-dropdown-menu us-menu">
                                                                <li v-if="user.useline === 1">
                                                                    <button @click="btnresetpassword(user)" class="ti-dropdown-item">
                                                                        <i class="ri-lock-password-line cf-menu-icon"></i> Réinitialiser le mot de passe
                                                                    </button>
                                                                </li>
                                                                <li>
                                                                    <button @click="btnmodifier(user)" class="ti-dropdown-item">
                                                                        <i class="ri-edit-line cf-menu-icon"></i> Modifier l'utilisateur
                                                                    </button>
                                                                </li>
                                                                <hr v-if="user.useline === 0" class="cf-menu-sep"/>
                                                                <li v-if="user.useline === 0">
                                                                    <button @click="btnsuppression(user)" class="ti-dropdown-item">
                                                                        <i class="ri-delete-bin-line cf-menu-icon"></i> Supprimer l'utilisateur
                                                                    </button>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    </td>

                                                </tr>
                                            </template>

                                            <template v-else>
                                                <tr>
                                                    <td colspan="20">
                                                        <div class="cf-empty">
                                                            <i class="ri-user-search-line"></i>
                                                            Aucun utilisateur ne correspond à vos critères de recherche.
                                                            <div v-if="searchword || statusFilter || roleFilter" class="mt-3">
                                                                <button @click="clearFilters" class="ds-btn-ghost">
                                                                    <i class="ri-filter-off-line"></i> Réinitialiser les filtres
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </template>

                                            </tbody>
                                        </table>

                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="flex flex-col box-footer border-t-0">
                            <div class="flex items-center flex-wrap gap-3 overflow-auto">
                                <button @click="load" :disabled="lastkey === null"
                                        class="ds-btn-ghost !py-1 !px-2 !text-[0.75rem]">
                                    <i class="ri-refresh-line align-middle"></i>
                                    Charger plus d'utilisateurs ({{ countPageItems }}/{{ countItems }})
                                </button>
                                <span class="text-xs cf-faint">
                                    {{ paginatedData.length }} affiché(s) sur {{ filteredData.length }} utilisateur(s) trouvé(s)
                                </span>
                                <button v-if="searchword || statusFilter || roleFilter" @click="clearFilters"
                                        class="ds-btn-ghost !py-1 !px-2 !text-[0.75rem]">
                                    <i class="ri-filter-off-line align-middle"></i> Effacer les filtres
                                </button>
                                <div class="ms-auto">
                                    <nav aria-label="Pagination">
                                        <ul class="ti-pagination mb-0">
                                            <li class="page-item">
                                                <button :class="{ 'disabled': page <= 1 }" :disabled="page <= 1"
                                                        class="page-link px-3 py-[0.375rem]" @click="page--">Précédent</button>
                                            </li>
                                            <li class="page-item">
                                                <button class="page-link px-3 py-[0.375rem]" :class="{ 'active': pageNumber === page }"
                                                        :key="key" v-for="(pageNumber, key) in displayedPages"
                                                        :disabled="pageNumber === '...'" @click="page = pageNumber">
                                                    {{ pageNumber }}
                                                </button>
                                            </li>
                                            <li class="page-item">
                                                <button :class="{ 'disabled': page >= pages.length }" :disabled="page >= pages.length"
                                                        class="page-link px-3 py-[0.375rem]" @click="page++">Suivant</button>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        </div>

                    </div>

                </div>

                <div class="ti-modal-footer">
                    <button @click="close" type="button" class="hs-dropdown-toggle ti-btn ti-btn-secondary-full">
                        Fermer
                    </button>
                </div>

            </div>
        </div>
    </div>

    <div v-if="isdisplay" data-hs-overlay-backdrop-template=""
         class="transition duration fixed inset-0 bg-gray-900 bg-opacity-50 hs-overlay-backdrop"
         style="z-index: 49;"></div>

    <!-- Modales filles. Frères du bloc ci-dessus (empilement modale sur modale). -->
    <modalform ref="modalform" @closed="loadtrrt" />
    <modalformsuppression @closed="loadtrrt" ref="modalformsuppression" />
    <resetpassword @closed="loadtrrt" ref="resetpassword" />
</template>

<script>
    const axios = require('axios');
    import modalform from "@/components/views/pages/setting/utilisateur/form";
    import modalformsuppression from "@/components/views/pages/setting/utilisateur/formsuppression";
    import resetpassword from "@/components/views/pages/setting/utilisateur/resetpassword";
    import { randomString } from "@/allfunction";
    import * as JwtService from "@/common/jwt.service";

    export default {
        name: "UserList",

        components: {
            modalform,
            resetpassword,
            modalformsuppression
        },

        data() {
            return {
                isdisplay: false,
                titlemodal: "",
                datatable: [],
                otherdata: [],
                otherdatamg: [],

                // UI State
                activeDropdown: null,
                sortField: 'name',
                sortDirection: 'asc',

                // Filters
                searchword: "",
                statusFilter: "",
                roleFilter: "",
                debounceTimer: null,

                // Quota licence (_nbrusers)
                quota: { max: 1, used: 0, atteint: false },

                // Pagination
                lastkey: 0,
                paginationpage: 1,
                nextPage: 1,
                countItems: 1,
                countPageItems: 0,

                // Local Pagination
                page: 1,
                perPage: 50,
                DefaultperPage: 50,
                pages: []
            };
        },

        computed: {
            filteredData() {
                let filtered = this.datatable;

                // Text search
                if (this.searchword) {
                    const searchTerm = this.searchword.toLowerCase();
                    filtered = filtered.filter(user => {
                        return (
                            (user.name || '').toLowerCase().includes(searchTerm) ||
                            (user.login || '').toLowerCase().includes(searchTerm) ||
                            (user.groupeusers || '').toLowerCase().includes(searchTerm) ||
                            (user.namerole || '').toLowerCase().includes(searchTerm) ||
                            (user.creerpar || '').toLowerCase().includes(searchTerm)
                        );
                    });
                }

                // Status filter
                if (this.statusFilter === 'active') {
                    filtered = filtered.filter(user => user.useline === 1);
                } else if (this.statusFilter === 'inactive') {
                    filtered = filtered.filter(user => user.useline === 0);
                }

                // Role filter
                if (this.roleFilter) {
                    filtered = filtered.filter(user => user.namerole === this.roleFilter);
                }

                // Sorting
                filtered.sort((a, b) => {
                    let aValue = a[this.sortField] || '';
                    let bValue = b[this.sortField] || '';

                    if (this.sortDirection === 'asc') {
                        return aValue.localeCompare(bValue);
                    } else {
                        return bValue.localeCompare(aValue);
                    }
                });

                return filtered;
            },

            paginatedData() {
                this.setPages();
                const start = (this.page - 1) * this.perPage;
                const end = start + this.perPage;
                return this.filteredData.slice(start, end);
            },

            displayedPages() {
                const start = Math.max(1, this.page - 2);
                const end = Math.min(this.pages.length, start + 4);

                let result = [];

                if (start > 1) {
                    result.push(1);
                    if (start > 2) {
                        result.push('...');
                    }
                }

                for (let i = start; i <= end; i++) {
                    result.push(i);
                }

                if (end < this.pages.length) {
                    if (end < this.pages.length - 1) {
                        result.push('...');
                    }
                    result.push(this.pages.length);
                }

                return result;
            },

            rolesList() {
                const roles = new Set();
                this.datatable.forEach(user => {
                    if (user.namerole) {
                        roles.add(user.namerole);
                    }
                });
                return Array.from(roles).map(role => ({
                    label: role,
                    value: role
                }));
            }
        },

        watch: {
            DefaultperPage(newValue) {
                this.perPage = parseInt(newValue);
                this.page = 1;
            },

            statusFilter() {
                this.page = 1;
            },

            roleFilter() {
                this.page = 1;
            }
        },

        /*mounted() {
            // Close dropdown when clicking outside
            document.addEventListener('click', this.closeDropdowns);
        },

        beforeUnmount() {
            document.removeEventListener('click', this.closeDropdowns);
        },*/

        methods: {


            async loadreturnotherdata_magasin() {
                try {
                    const url = `${process.env.VUE_APP_API_URL}/jkebfiuebffeznfoieznofibeubqsyudfyegl745874stock771714dfe/stock/othetdskd8755dsdhisd/${this.$store.state.appsociete}/${randomString()}`;

                    const response = await axios.get(url, {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${JwtService.getToken()}`,
                            'csrftoken': this.$store.state.appsociete,
                        },
                        withCredentials: true,
                    });

                    if (response.data.success) {
                        this.otherdatamg = response.data.otherdata || {};
                    }
                } catch (error) {
                    console.error('Error loading other data:', error);
                }
            },
 
            // UI Methods
            closeDropdowns(event) {
                if (!event.target.closest('.relative')) {
                    this.activeDropdown = null;
                }
            },

            toggleActionsDropdown(index) {
                this.activeDropdown = this.activeDropdown === index ? null : index;
            },

            sortBy(field) {
                if (this.sortField === field) {
                    this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
                } else {
                    this.sortField = field;
                    this.sortDirection = 'asc';
                }
            },

            debouncedSearch() {
                clearTimeout(this.debounceTimer);
                this.debounceTimer = setTimeout(() => {
                    this.page = 1;
                }, 300);
            },

            clearFilters() {
                this.searchword = "";
                this.statusFilter = "";
                this.roleFilter = "";
                this.page = 1;
            },

            // Data Methods
            close() {
                document.removeEventListener('click', this.closeDropdowns);
                this.isdisplay = false;
            },

            async load() {
                if (this.nextPage === null) return;

                this.$store.dispatch('lancerchargement', true);
                const t = this;

                let url = `${process.env.VUE_APP_API_URL}/setting/utilisateur/${this.$store.state.appsociete}/alluser/${this.lastkey}/${this.paginationpage}/${randomString()}`;

                try {
                    const response = await axios.get(url, {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + JwtService.getToken(),
                            'csrftoken': this.$store.state.appsociete
                        },
                        withCredentials: true
                    });

                    if (response.data.success) {
                        if (response.data.quota) t.quota = response.data.quota;
                        if (t.paginationpage === 1) {
                            t.datatable = response.data.m;
                        } else {
                            t.datatable.push(...response.data.m);
                        }

                        t.nextPage = response.data.pagination.nextPage;
                        t.lastkey = response.data.pagination.lastkey;
                        t.paginationpage++;
                        t.countPageItems++;

                        if (response.data.pagination.nextPage !== null) {
                            t.countItems++;
                        }

                        t.isdisplay = true;
                    } else {
                        t.datatable = [];
                        t.isdisplay = true;
                    }
                } catch (error) {
                    console.error('Error loading users:', error);
                } finally {
                    t.$store.dispatch('lancerchargement', false);
                }
            },

            async loadtrrt() {
                this.datatable = [];
                this.lastkey = 0;
                this.paginationpage = 1;
                this.nextPage = 1;
                this.countItems = 1;
                this.countPageItems = 0;

                await this.load();
            },

            async loadreturnotherdata() {
                const t = this;
                let url = `${process.env.VUE_APP_API_URL}/setting/profil/${this.$store.state.appsociete}/allprofil/${randomString(200)}`;

                try {
                    const response = await axios.get(url, {
                        headers: {
                            'X-Requested-With': 'XMLHttpRequest',
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + JwtService.getToken(),
                            'csrftoken': this.$store.state.appsociete
                        },
                        withCredentials: true
                    });

                    if (response.data.success) {
                        t.otherdata = response.data.m;
                    } else {
                        t.otherdata = [];
                    }
                } catch (error) {
                    console.error('Error loading profiles:', error);
                }
            },

            // Action Methods
            btnajouter() {
                if (this.quota.used >= this.quota.max) {
                    this.$store.dispatch('showToast', {
                        message: `Limite d'utilisateurs atteinte (${this.quota.used}/${this.quota.max}). Contactez votre support.`,
                        type: 'error'
                    });
                    return;
                }

                let Item = {
                    useline: 0,
                    pid: '',
                    name: '',
                    login: '',
                    groupeusers: 'NONE',
                    sysrole: null,
                    agence:[]
                };

                let mname = 'Enregistrer un utilisateur';
                this.$refs.modalform.show(mname, "add", Item, this.otherdata,this.otherdatamg);
            },

            btnmodifier(user) {
               /* if (user.useline === 1 || user.useline === '1') {
                    this.$store.dispatch('showToast', {
                        message: "Impossible de modifier cet utilisateur. Veuillez contacter votre administrateur.",
                        type: 'error'
                    });
                    return;
                }*/

                let titlemodal = `Modifier l'utilisateur ${user.name}`;
                this.$refs.modalform.show(titlemodal, "update", user, this.otherdata,this.otherdatamg);
            },

            btnsuppression(user) {
                if (user.useline === 1 || user.useline === '1') {
                    this.$store.dispatch('showToast', {
                        message: "Impossible de supprimer cet utilisateur. Veuillez contacter votre administrateur.",
                        type: 'error'
                    });
                    return;
                }

                let titlemodal = `VOULLEZ-VOUS VRAIMENT SUPPRIMER L'UTILISATEUR ${user.name} ?`;
                this.$refs.modalformsuppression.show(titlemodal, user, "");
            },

            btnresetpassword(user) {
                if (parseFloat(user.useline) !== 1) {
                    this.$store.dispatch('showToast', {
                        message: "Impossible de réinitialiser le mot de passe de l'utilisateur. Veuillez contacter votre administrateur.",
                        type: 'error'
                    });
                    return;
                }

                let titlemodal = `VOULLEZ-VOUS VRAIMENT RÉINITIALISER LE MOT DE PASSE DE L'UTILISATEUR ${user.name} ?`;
                this.$refs.resetpassword.show(titlemodal, user, "");
            },

            // View Methods
            viewUserDetails(user) {
                // Implement user details view logic
                console.log('View user details:', user);
            },

            viewUserActivity(user) {
                // Implement user activity view logic
                console.log('View user activity:', user);
            },

            show() {
                document.addEventListener('click', this.closeDropdowns);
                this.titlemodal = "Liste des utilisateurs";
                this.datatable = [];
                this.lastkey = 0;
                this.paginationpage = 1;
                this.nextPage = 1;
                this.countItems = 1;
                this.countPageItems = 0;
                this.clearFilters();
                this.loadreturnotherdata();
                this.loadreturnotherdata_magasin();
                this.load();
            },

            // Helper Methods
            setPages() {
                const numberOfPages = Math.ceil(this.filteredData.length / this.perPage);
                this.pages = Array.from({ length: numberOfPages }, (_, i) => i + 1);
            },

            paginate(posts) {
                this.setPages();
                let from = (this.page * this.perPage) - this.perPage;
                let to = (this.page * this.perPage);

                let $res = posts.slice(from, to);

                if ($res.length > 0) {
                    return $res;
                } else {
                    return posts;
                }
            },

            // Formatting Methods
            formatDate(dateString) {
                if (!dateString) return '-';
                const date = new Date(dateString);
                return date.toLocaleDateString('fr-FR');
            },

            formatTime(dateString) {
                if (!dateString) return '';
                const date = new Date(dateString);
                return date.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
            },

            getUserInitials(username) {
                if (!username) return '??';
                return username
                    .split(' ')
                    .map(name => name[0])
                    .join('')
                    .toUpperCase()
                    .substring(0, 2);
            },

            getUserAvatarClass(user) {
                const colors = [
                    'bg-blue-600', 'bg-green-600', 'bg-purple-600',
                    'bg-pink-600', 'bg-indigo-600', 'bg-yellow-600'
                ];
                const index = Math.abs(user.name?.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0)) % colors.length;
                return colors[index] || 'bg-gray-600';
            },

            getGroupBadgeClass(group) {
                const groups = {
                    'ADMIN': 'bg-purple-100 text-purple-800',
                    'MANAGER': 'bg-blue-100 text-blue-800',
                    'USER': 'bg-green-100 text-green-800',
                    'GUEST': 'bg-gray-100 text-gray-800',
                    'NONE': 'bg-yellow-100 text-yellow-800'
                };
                return groups[group] || 'bg-gray-100 text-gray-800';
            }
        }
    };
</script>

<style scoped>
    /* Menu d'actions piloté par Vue (activeDropdown), sans le JS Preline.
       Seul le positionnement est défini ici : l'apparence vient de ti-dropdown-menu.
       Le conteneur garde la classe .relative car le script ferme le menu via
       closeDropdowns -> event.target.closest('.relative'). */
    .us-actions { position: relative; display: inline-block; }
    .us-menu {
        position: absolute; right: 0; top: 100%;
        display: block; opacity: 1; text-align: left;
    }

    /* En-tête de table figé pendant le défilement de la zone scrollable. */
    table thead { position: sticky; top: 0; z-index: 10; }
</style>